import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastForward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFastForward"><Path d="M12.9924 11.5587V6.67283C12.9924 5.81868 13.9941 5.3577 14.6429 5.9133L20.8631 11.2403C21.3292 11.6394 21.3292 12.3602 20.8631 12.7594L14.6429 18.0864C13.9941 18.642 12.9924 18.181 12.9924 17.3268V12.441M12.9924 11.5587L6.40047 5.9133C5.75171 5.3577 4.75 5.81868 4.75 6.67283V17.3268C4.75 18.181 5.75171 18.642 6.40047 18.0864L12.9924 12.441M12.9924 11.5587V12.441" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFastForward;
